module.exports = __webpack_public_path__ + "static/media/U1-T2-2-3e.f76a6127.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-3e.svg
// module id = 552
// module chunks = 0